export default __webpack_public_path__ + "static/media/in_case_of_EMERGENCY.2a8018b3.pdf";